<template>
  <div class="container" style="position: relative;">
    <HeaderTv />
    <main class="main" v-if="tableList">
      <div class="table-title" style="height: 30px; border-top-left-radius: 20px; border-top-right-radius: 20px;">
        <div class="main-trs" style="border-top: 1px solid white; border-top-left-radius: 20px; border-top-right-radius: 20px;">
          <div class="t-th">商品</div>
          <div class="t-th">回购</div>
          <div class="t-th">销售</div>
          <div class="t-th">高/低</div>
        </div>
      </div>
      <div class="t-tr" v-if="GLOBAL.selectMap.map(item => {return item.state;})">
        <div v-for="(item, index) in GLOBAL.selectMap" :key="index" v-if="item.state">
          <div class="t-tr-sea" v-if="tableList[item.type]">
            <div class="t-td" style="color: black;font-size: 17px;">{{ item.name }}</div>
            <div class="t-td" :style="handleColor(item.type)" >{{ tableList[item.type].Buy === '0.00' ? '--' : tableList[item.type].Buy }}</div>
            <div class="t-td" :style="handleColor(item.type)">{{ tableList[item.type].Sell === '0.00' ? '--' : tableList[item.type].Sell }}</div>
            <div class="t-td">
              <div style="font-size: 14px;line-height: 27px;" :style="handleMaxColor(item.type)">
                {{ tableList[item.type].H === '0.00' ? '--' : tableList[item.type].H }}
              </div>
              <div style="font-size: 14px;line-height: 9px;" :style="handleMinColor(item.type)">
                {{ tableList[item.type].L === '0.00' ? '--' : tableList[item.type].L }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="explain">
        <div>
          <a style="color: #4C4141">声明：</a>
          <a style="color: #CBAB65;">以上行情仅供参考!</a>
        </div>
        <div>电话：18927400408</div>
        <div>地址：广东省深圳市罗湖区水贝万山D座一楼点金快线</div>
      </div>
    </main>
  </div>
</template>
<script>
import HeaderTv from '@/components/HeaderTv.vue'
import { EventBus } from '../common/eventBus.js'

export default {
  name: 'Home',
  data () {
    return {
      tableList: []
    }
  },
  components: {
    HeaderTv
  },
  computed: {
  },
  created () {
    EventBus.$on('tabListUpdated', updatedTabList => {
      this.tableList = updatedTabList
    })

    document.title = '点金快线'
    const favicon = document.querySelector('link[rel="icon"]')
    favicon.href = '../../static/favicon.ico'
  },
  mounted () {
  },
  methods: {
    handleColor (index) {
      let sell = parseFloat(this.tableList[index].Sell)
      let mean = (parseFloat(this.tableList[index].H) + parseFloat(this.tableList[index].L)) / 2
      return sell > mean ? 'color:#BC0A12;' : sell < mean ? 'color:#4D9F79' : 'color:black'
    },
    handleMaxColor (index) {
      return this.tableList[index].H === '-' ? 'color:#e8e8e8' : 'color:#BC0A12'
    },
    handleMinColor (index) {
      return this.tableList[index].L === '-' ? 'color:#e8e8e8' : 'color:#6BB193'
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/HomeTv.vue